import { RootState } from '../../store'
import {
  CompareGroupType,
  StudyObjectType,
} from '../../../components/analytics-details-v2/view/readership-profile/configs/StudiesObjectsCompareGroupTypesConfig'
import {
  CompareGroupValueType,
  NewReadershipProfileStepEnum,
  StudyObjectValueType,
} from '../../interfaces/analytics-details/new-readership-profile-state.interface'
import { ReadershipProfilePreviewInterface } from '../../../core/interface/analytics/readership-profile-preview.interface'
import { AnalyticDetailsInterface } from '../../../core/interface/analytics/analytic-details.interface'
import { AnalyticPreviewTypeErrorEnum } from '../../../core/enums/analytic-preview-type-error'
import { BookInterface } from '../../../core/interface/book.interface'
import { DateFilterTypeEnum } from '../../../core/enums/date-filter-type.enum'
import { ReadershipProfilePreviewInputsInterface } from '../../../core/interface/analytics/readership-profile-preview-inputs.interface'
import { ReadershipProfilePreviewUsersInputInterface } from '../../../core/interface/analytics/readership-profile-preview-users-input.interface'
import NewReadershipProfileBookFiltersInterface from '../../../core/interface/analytics/new-readership-profile-book-filters'

export const selectNewAnalyticsReadershipProfileStateStep = (
  state: RootState,
): NewReadershipProfileStepEnum => {
  const { step } = state.newAnalyticsReadershipProfileState
  return step
}
export const selectNewAnalyticsReadershipProfileStateStudyObjectType = (
  state: RootState,
): StudyObjectType => {
  const { studyObjectType } = state.newAnalyticsReadershipProfileState
  return studyObjectType
}

export const selectNewAnalyticsReadershipProfileStateStudyObjectValue = (
  state: RootState,
): StudyObjectValueType => {
  const { studyObjectValue } = state.newAnalyticsReadershipProfileState
  return studyObjectValue
}

export const selectNewAnalyticsReadershipProfileStateStudyObjectBooks = (
  state: RootState,
): BookInterface[] => {
  const { studyObjectBooks } = state.newAnalyticsReadershipProfileState
  return studyObjectBooks
}

export const selectNewAnalyticsReadershipProfileStateCompareGroupType = (
  state: RootState,
): CompareGroupType => {
  const { compareGroupType } = state.newAnalyticsReadershipProfileState
  return compareGroupType
}

export const selectNewAnalyticsReadershipProfileStateCompareGroupValue = (
  state: RootState,
): CompareGroupValueType => {
  const { compareGroupValue } = state.newAnalyticsReadershipProfileState
  return compareGroupValue
}
export const selectNewAnalyticsReadershipProfileStateCompareGroupBooks = (
  state: RootState,
): BookInterface[] => {
  const { compareGroupBooks } = state.newAnalyticsReadershipProfileState
  return compareGroupBooks
}

export const selectNewAnalyticsReadershipProfileStateIsLoadingPostPreview = (
  state: RootState,
): boolean => {
  const { isLoadingPostPreview } = state.newAnalyticsReadershipProfileState
  return isLoadingPostPreview
}

export const selectNewAnalyticsReadershipProfileStatePostPreviewSuccess = (
  state: RootState,
): boolean => {
  const { postPreviewSuccess } = state.newAnalyticsReadershipProfileState
  return postPreviewSuccess
}

export const selectNewAnalyticsReadershipProfileStatePostPreviewError = (
  state: RootState,
): boolean => {
  const { postPreviewError } = state.newAnalyticsReadershipProfileState
  return postPreviewError
}

export const selectNewAnalyticsReadershipProfileStateIsLoadingGetPreviewById = (
  state: RootState,
): boolean => {
  const { isLoadingGetPreviewById } = state.newAnalyticsReadershipProfileState
  return isLoadingGetPreviewById
}

export const selectNewAnalyticsReadershipProfileStateGetPreviewByIdSuccess = (
  state: RootState,
): boolean => {
  const { getPreviewByIdSuccess } = state.newAnalyticsReadershipProfileState
  return getPreviewByIdSuccess
}
export const selectNewAnalyticsReadershipProfileStateGetPreviewByIdError = (
  state: RootState,
): boolean => {
  const { getPreviewByIdError } = state.newAnalyticsReadershipProfileState
  return getPreviewByIdError
}

export const selectNewAnalyticsReadershipProfileStatePreviewOutput = (
  state: RootState,
): ReadershipProfilePreviewInterface | null => {
  const { previewOutput } = state.newAnalyticsReadershipProfileState
  return previewOutput
}

export const selectNewAnalyticsReadershipProfileStatePreviewInputs = (
  state: RootState,
): ReadershipProfilePreviewInputsInterface | null => {
  const { previewInputs } = state.newAnalyticsReadershipProfileState
  return previewInputs
}

export const selectNewAnalyticsReadershipProfileStateIsLoadingReadershipProfileValidation =
  (state: RootState): boolean => {
    const { isLoadingReadershipProfileValidation } =
      state.newAnalyticsReadershipProfileState
    return isLoadingReadershipProfileValidation
  }

export const selectNewAnalyticsReadershipProfileStateAnalyticsReadershipProfilePreview =
  (state: RootState): AnalyticDetailsInterface | null => {
    const { analyticsReadershipProfilePreview } =
      state.newAnalyticsReadershipProfileState
    return analyticsReadershipProfilePreview
  }

export const selectNewAnalyticsReadershipProfileStatePutReadershipProfileValidateSuccess =
  (state: RootState): boolean => {
    const { putReadershipProfileValidateSuccess } =
      state.newAnalyticsReadershipProfileState
    return putReadershipProfileValidateSuccess
  }

export const selectNewAnalyticsReadershipProfileStatePutReadershipProfileValidateError =
  (state: RootState): boolean => {
    const { putReadershipProfileValidateError } =
      state.newAnalyticsReadershipProfileState
    return putReadershipProfileValidateError
  }

export const selectNewAnalyticsReadershipProfileStatePostPreviewTypeError = (
  state: RootState,
): AnalyticPreviewTypeErrorEnum => {
  const { postPreviewTypeError } = state.newAnalyticsReadershipProfileState
  return postPreviewTypeError
}

export const selectAnalyticsStudyObjectFiltersActions = (
  state: RootState,
): NewReadershipProfileBookFiltersInterface => {
  const { newAnalyticsReadershipProfileState } = state
  return newAnalyticsReadershipProfileState.studyObjectFiltersActions
}

export const selectAnalyticsCompareGroupFiltersActions = (
  state: RootState,
): NewReadershipProfileBookFiltersInterface => {
  const { newAnalyticsReadershipProfileState } = state
  return newAnalyticsReadershipProfileState.compareGroupFiltersActions
}

export const selectAnalyticsStudyObjectFiltersPayload = (
  state: RootState,
): ReadershipProfilePreviewUsersInputInterface => {
  const { newAnalyticsReadershipProfileState } = state
  return newAnalyticsReadershipProfileState.studyObjectFiltersPayload
}

export const selectAnalyticsCompareGroupFiltersPayload = (
  state: RootState,
): ReadershipProfilePreviewUsersInputInterface => {
  const { newAnalyticsReadershipProfileState } = state
  return newAnalyticsReadershipProfileState.compareGroupFiltersPayload
}
